import type { KeyboardEvent } from 'react';

import type { ITableRow } from '../../../types/table/table_row';

import styles from './table-row.module.scss';

/** Keys that activate a row, matching how a button behaves. */
const ACTIVATION_KEYS = ['Enter', ' '];

export const TableRow = ({
  children,
  onClickHandler,
  stickyOnOverflow,
  ariaHidden,
}: ITableRow) => {
  /**
   * A clickable row is only reachable with a mouse unless it also answers to
   * the keyboard, so Enter and Space activate it the way a button would.
   */
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!onClickHandler || !ACTIVATION_KEYS.includes(event.key)) return;
    if (event.target !== event.currentTarget) return;

    // Space would otherwise scroll the page.
    event.preventDefault();
    onClickHandler(event as unknown as Parameters<typeof onClickHandler>[0]);
  };

  return (
    <div
      className={styles['table-row']}
      role="row"
      aria-hidden={ariaHidden || undefined}
      tabIndex={onClickHandler && !ariaHidden ? 0 : undefined}
      onClick={onClickHandler}
      onKeyDown={onClickHandler ? handleKeyDown : undefined}
      data-table-row-sticky-on-overflow={stickyOnOverflow}
    >
      {children}
    </div>
  );
};
